import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { ThreeFoursBanner } from 'widgets/ThreeFours';
import { getThreeFoursAvailability } from 'store/widgets/ThreeFours/selectors';
import { getPromoBanners } from 'store/ProductCatalog/selectors';
import IncludeBannerContent from 'bricks/IncludeBannerContent';
import { onBannerView, onBannerClick } from 'store/ProductCatalog/actions';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export class PromoBannerLayout extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      bannerIndex: 0,
      bannerInterval: false,
      bannerHover: false,
      focus: false, // на баннер нажали
      focusClientX: 0, // стартовое значение clientX
    };

    this.viewportEl = React.createRef();
    this.overviewEl = React.createRef();
  }

  componentDidMount() {
    const viewportEl = this.viewportEl.current || {};
    const overviewEl = this.overviewEl.current || {};

    window.onresize = () => {
      const viewportWidth = viewportEl.offsetWidth || 0;
      (overviewEl.style || {}).transform = `translateX(-${
        viewportWidth * this.state.bannerIndex
      }px)`;
    };

    const setStartVariation = () => {
      const viewportWidth = viewportEl.offsetWidth || 0;
      const overviewElStyle = (this.overviewEl.current || {}).style || {};
      this.setState({ bannerHover: false, focus: false, focusClientX: 0 });
      overviewElStyle.transition = '0.3s';
      overviewElStyle.transform = `translateX(-${viewportWidth * this.state.bannerIndex}px)`;
    };

    viewportEl.onmouseenter = () => {
      this.setState({ bannerHover: true });
    };

    viewportEl.onmouseleave = setStartVariation;

    viewportEl.onmousedown = (e) => {
      this.setState({ focus: true, focusClientX: e.clientX });
    };

    viewportEl.onmousemove = (e) => {
      if (this.state.focus && this.state.bannerHover) {
        const viewportWidth = (this.viewportEl.current || {}).offsetWidth || 0;
        const variation = this.state.focusClientX - e.clientX;
        const overviewElStyle = (this.overviewEl.current || {}).style || {};
        overviewElStyle.transition = 'none';
        overviewElStyle.transform = `translateX(-${
          viewportWidth * this.state.bannerIndex + variation
        }px)`;
      }
    };

    viewportEl.onmouseup = (e) => {
      const viewportWidth = (this.viewportEl.current || {}).offsetWidth || 0;
      const variation = this.state.focusClientX - e.clientX;
      ((this.overviewEl.current || {}).style || {}).transition = '0.3s';
      if (variation < 0 && Math.abs(variation) > viewportWidth / 5) {
        this.onPrev();
      }
      if (variation > 0 && Math.abs(variation) > viewportWidth / 5) {
        this.onNext();
      }
      this.setState({ focus: false, focusClientX: 0 });
    };

    // touch events
    viewportEl.ontouchstart = (e) => {
      // onmousedown && onmouseenter
      const { clientX } = e.touches[0];
      this.setState({ bannerHover: true, focus: true, focusClientX: clientX });
    };

    viewportEl.ontouchmove = (e) => {
      // onmousemove
      e.preventDefault();
      if (this.state.focus && this.state.bannerHover) {
        const viewportWidth = (this.viewportEl.current || {}).offsetWidth || 0;
        const { clientX } = e.touches[0];
        const variation = this.state.focusClientX - clientX;
        const overviewElStyle = (this.overviewEl.current || {}).style || {};
        overviewElStyle.transition = 'none';
        overviewElStyle.transform = `translateX(-${
          viewportWidth * this.state.bannerIndex + variation
        }px)`;
      }
    };

    viewportEl.ontouchend = (e) => {
      // mouseup
      const viewportWidth = (this.viewportEl.current || {}).offsetWidth || 0;
      const { clientX } = e.changedTouches[0];
      const variation = this.state.focusClientX - clientX;
      const overviewElStyle = (this.overviewEl.current || {}).style || {};
      overviewElStyle.transition = '0.3s';
      if (variation < 0 && Math.abs(variation) > viewportWidth / 5) {
        this.onPrev();
      }
      if (variation > 0 && Math.abs(variation) > viewportWidth / 5) {
        this.onNext();
      }
      if (Math.abs(variation) < viewportWidth / 5) {
        setStartVariation();
      }
      this.setState({ focus: false, focusClientX: 0 });
    };

    // interval
    if (!this.state.bannerInterval) {
      this.setBannerInterval(true);
      setInterval(() => {
        if (!this.state.bannerHover && !this.state.focus) {
          this.onNext();
        }
      }, 15000);
    }
  }

  setBannerInterval = (status) => {
    this.setState({ bannerInterval: status });
  };

  setBannerIndex = (index) => {
    this.setState({ bannerIndex: index });
  };

  onPrev = () => {
    const { list } = this.props;
    const { bannerIndex } = this.state;
    const ind = bannerIndex === 0 ? list.length - 1 : bannerIndex - 1;
    this.setState({ bannerIndex: ind });
  };

  onNext = () => {
    const { list } = this.props;
    const { bannerIndex } = this.state;
    const ind = bannerIndex === list.length - 1 ? 0 : bannerIndex + 1;
    this.setState({ bannerIndex: ind });
  };

  render() {
    const { list, hasThreeFours, isMobile } = this.props;
    const { bannerIndex } = this.state;
    const viewportWidth = (this.viewportEl.current || {}).offsetWidth || 0;
    return list.length > 0 ?
        <div id="catalogPromoBanner">
          <div className={cx('viewport')} ref={this.viewportEl}>
            <div
              className={cx('overview')}
              ref={this.overviewEl}
              style={{ transform: `translateX(-${viewportWidth * bannerIndex}px)` }}
            >
              {list.map((banner, index) =>
                (banner || {}).isThreefours && hasThreeFours ?
                  <div className={cx('item')} key={+index}>
                    <ThreeFoursBanner isMobile={isMobile} />
                  </div>
                : <div className={cx('item')} key={+index}>
                    <IncludeBannerContent
                      htmlContent={(banner || {}).markup}
                      className={cx('includeBanner')}
                    />
                  </div>,
              )}
            </div>
            {list.length > 1 ?
              <>
                <div className={cx('prev')} onClick={this.onPrev} role="button" tabIndex={0} />
                <div className={cx('next')} onClick={this.onNext} role="button" tabIndex={0} />
                <div className={cx('dots')}>
                  {list.map((banner, index) => (
                    <div
                      className={cx('dot', index === bannerIndex ? 'dotActive' : '')}
                      key={+index}
                      onClick={() => {
                        this.setBannerIndex(index);
                      }}
                      role="button"
                      tabIndex={0}
                    />
                  ))}
                </div>
              </>
            : null}
          </div>
        </div>
      : null;
  }
}

PromoBannerLayout.propTypes = {
  list: PropTypes.array,
  hasThreeFours: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  list: getPromoBanners(state),
  hasThreeFours: getThreeFoursAvailability(state),
  isMobile: isScreenBelow640(state),
});

const mapDispatchToProps = {
  onView: onBannerView,
  onClick: onBannerClick,
};

const PromoBanner = connect(mapStateToProps, mapDispatchToProps)(PromoBannerLayout);
export default PromoBanner;
